import {
    Link, Text
} from "@fluentui/react";
import { RootState } from "app/store";
import { AppLinkTo, appStyles } from "global/Application";
import {
    IBenefit as FAM_IBenefit,
    IPlan as FAM_IPlan
} from "model/FlexibleAttributeModel";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { EBenefitCardFunction } from "views/BlueRelationship/BenefitCard";

interface IProps {
    contextPlans?: FAM_IPlan[];
    benefit: FAM_IBenefit;
    mode: EBenefitCardFunction;
}

const BenefitCallout: React.FunctionComponent<IProps> = (props) => {

    const history = useHistory();
    const state = useSelector((state: RootState) => state);
    const associationTemplateName = (props.benefit as any).associationTemplateName;

    const plans = React.useMemo(() => {
        const plans: FAM_IPlan[] = [];

        props.contextPlans?.forEach(eachPlan => {
            if (eachPlan.deactivated)
                return;

            if (eachPlan.benefitRefs.some(q => q.id === props.benefit.id))
                plans.push(eachPlan);
        });

        return plans;

    }, [props.contextPlans])

    return <>
        <Text block variant="xLarge" className={appStyles.title}>
            Benefit - {props.benefit.bcbs_name}
        </Text>
        <Text block variant="mediumPlus" className={appStyles.calloutContent}>
            Funding Type: {props.benefit.fundingType?.name}<br />
            GF/NGF Type: {props.benefit.grandFathered?.name}<br />
            Tier: {props.benefit.tierSetRef?.name ?? 'N/A'}<br />
            {associationTemplateName && (
                <>Template: {associationTemplateName}</>
            )}
        </Text>

        {props.mode === EBenefitCardFunction.display && plans.length > 0 &&
            <>
                <Text block variant="xLarge" className={appStyles.title}>
                    Plans ({plans.length})
                </Text>
                <ul className={appStyles.cardPadding}>
                    {plans.map(p =>
                        <li key={p.id}>
                            <Link onClick={() => history.push(AppLinkTo(state, { type: 'plan', id: p?.id! }))}>
                                <Text variant="small">
                                    {p?.name}
                                </Text>
                            </Link>
                        </li>
                    )}
                </ul>
            </>
        }
    </>;
}
export default BenefitCallout;